import Morphology from "./Morphology";

export default class MorphologyLookup {

    private morphology: Map<string, string>;

    public constructor(morphology: Morphology[]) {
        this.morphology = new Map(morphology.map(morph =>
            [morph.getCode(), morph.getDescription()] as [string, string]));
    }

    public getDescription(code: string): string {
        const description = this.morphology.get(code);
        return description !== undefined ? description : '';
    }
}
